import { PatientModel } from "src/models/patient";
import { ApiService } from "../apiService";
import { PatientService } from "src/models/patient-service";
import { Drug } from "src/sections/service/special-service/drug-search";
import { ComplaintLog } from "src/sections/patient/patient_query";
import axios from "axios";


const apiService = new ApiService();

export const getPatientList =(id:string) =>  apiService.get<PatientModel[]>(`Patient/GetPatientDetails?id=${id}`);

export const updatePatientData = (patient: PatientModel) => apiService.post('Patient/CreateorUpdatePatient',{...patient, createdDate: new Date().valueOf()});

export const deletePatientById = (id:number) => apiService.post(`Patient/DeletePatient?id=${id}`,{});

export const getPatientWaiting =(id:number) => apiService.get<PatientService[]>(`Patient/GetConsultantPendingDetails?id=${id}`);

export const getPatientHistory =(id:number) => apiService.get<PatientService[]>(`Patient/GetConsultantCompletedDetails?id=${id}`);

export const getSelectedDrugs = (id:number) => apiService.get<Drug[]>(`Patient/GetDrugsById?ConsultationId=${id}`);

export const getPatientComplaintById = (id:number) => apiService.get<ComplaintLog[]>(`Patient/GetPatientComplaint?patientId=${id}`);

export const createPatientLog = async(data:any) => await apiService.post(`Patient/CreatePatientLog`,data);

export const getPatientLogs = async () => await apiService.get<ComplaintLog[]>(`Patient/GetPatientLog`);

export const getPatientRestStatus =(id:string) =>  apiService.get<PatientModel[]>(`Patient/GetPatientResetStatus?id=${id}`);

export const getBookedSlot =(id:number) => apiService.get<PatientService[]>(`Patient/GetPatientBookedSlot?id=${id}`);

export const updateConsultationStatus = (id: number) =>
  apiService.post("Home/UpdateConsultationStatus", null, {
    params: { consultationId: id },
  });

  

